export default __webpack_public_path__ + "static/media/self-pic.e0e50173.png";